import React from 'react';

import { SignInAccount } from '../../molecules';
import { DefaultLayout } from '../../layouts';

const SignIn = props => {
  return (
    // <DefaultLayout>
      <SignInAccount />
    // </DefaultLayout>
  );
};

export default SignIn;
